type ObjectOrNullable<T> = T | null | { [key: string]: T | ObjectOrNullable<T> };

/**
 * given an object, returns the same object with all empty strings values
 * converted to null, recursively
 * @param obj object to parse
 */
export function nullAllEmptyStrings<T>(obj: ObjectOrNullable<T>): ObjectOrNullable<T> {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => nullAllEmptyStrings(item)) as ObjectOrNullable<T>;
  }

  const newObj: ObjectOrNullable<T> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {

      const value = obj[key as keyof ObjectOrNullable<T>] as ObjectOrNullable<T>;

      if (typeof value === "string" && value === "") {
        newObj[key] = null;
      } else if (typeof value === "object" && value !== null) {
        newObj[key] = nullAllEmptyStrings(value);
      } else {
        newObj[key] = value;
      }
    }
  }
  return newObj;
};
